import api from '@/api/schoolManagement'

const state = {

}

const actions = {
  getSchoolManagementList (context, params) {
    return api.getSchoolManagementList(params)
  },
  createSchool (context, params) {
    return api.createSchool(params)
  },
  updateSchool (context, params) {
    return api.updateSchool(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
